import { USERS_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/login`,
        method: "POST",
        body: data,
      }),
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}`,
        method: "POST",
        body: data,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: "POST",
      }),
    }),
    profile: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: "PUT",
        body: data,
      }),
    }),
    getUsers: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: USERS_URL,
        params: {
          keyword,
          pageNumber,
        },
      }),
      providesTags: ["Users"],
      keepUnusedDataFor: 5,
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: "DELETE",
      }),
    }),
    getUserDetails: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/${data.userId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    // Endpoint for email verification
    verifyEmail: builder.mutation({
      query: (token) => ({
        url: `${USERS_URL}/verify-email`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    resendVerificationEmail: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/resend-verification-email`,
        method: "POST",
      }),
    }),
    // Endpoint for password reset request
    sendResetEmail: builder.mutation({
      query: (email) => ({
        url: `${USERS_URL}/password-reset-request`,
        method: "POST",
        body: { email },
      }),
    }),
    // Endpoint for resetting the password
    resetPassword: builder.mutation({
      query: ({ password, token }) => ({
        url: `${USERS_URL}/password-reset`,
        method: "POST",
        body: { password },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useProfileMutation,
  useGetUsersQuery,
  useDeleteUserMutation,
  useGetUserDetailsQuery,
  useUpdateUserMutation,
  useVerifyEmailMutation,
  useSendResetEmailMutation,
  useResetPasswordMutation,
  useResendVerificationEmailMutation,
} = usersApiSlice;
